import React from 'react';
import { BeforeAfterAndBonuses, GuaranteeAndCost, PainAndTransformation, ProductOverview, SocialAndFAQ, Testimonials } from './components/ContentSections';
import { FloatingElements } from './components/Floating';
import { Footer } from './components/Footer';
import { Hero } from './components/Hero';
import { MetaPixel } from './components/MetaPixel';
import { Pricing } from './components/Offers';
import { TopBar } from './components/TopBar';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-canvas text-slate-600 selection:bg-primary selection:text-white" data-id="element-0" data-mp="2mm2j470bqezq">
      <MetaPixel data-id="element-1" data-mp="31brzh9gzmpkl" />
      <TopBar data-id="element-2" data-mp="31c9ygdv1bhw7" />
      <main data-id="element-3" data-mp="31ctflscv2296">
        <Hero data-id="element-4" data-mp="2wk09p15nonvi" />
        <Testimonials data-id="element-5" data-mp="2wka02pum4x1q" />
        <PainAndTransformation data-id="element-6" data-mp="2wiyx2s8zrtbo" />
        <ProductOverview data-id="element-7" data-mp="2wip734ny5m5z" />
        <BeforeAfterAndBonuses data-id="element-8" data-mp="28ufo0ai4bcij" />
        <Pricing data-id="element-9" data-mp="28tmi1bqzgr1g" />
        <SocialAndFAQ data-id="element-10" data-mp="28t4j27cxrypu" />
        <GuaranteeAndCost data-id="element-11" data-mp="28sbbx5a2f776" />
      </main>
      <Footer data-id="element-12" data-mp="23vupqgmff2wq" />
      <FloatingElements data-id="element-13" data-mp="23u9tmmkgrbwr" />
      <noscript data-id="element-14" data-mp="23ut97wmn5o7m">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=3123699361155808&ev=PageView&noscript=1" alt="" data-id="element-15" data-mp="23t8h0dnsuhcx" />
      </noscript>
    </div>;
}